//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Code from './code.vue';
import { LOGIN_STEP } from '@/utils/constant';
import { gotoHome } from '@/utils/util';

export default {
  name: 'Account',
  components: { Code },
  props: {
    storage: {
      type: Boolean,
      default: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    fromUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    // 只有在按下登录后没有拿到手机号才会触发这个错误
    const hasPhone = (rule, value, callback) => {
      if (this.needCode && this.phone === '') {
        callback(new Error('该账号未绑定手机号，请联系管理员绑定手机号后登录'));
      } else {
        callback();
      }
    };
    return {
      formData: {
        account: '',
        password: '',
      },
      // 是否自动登录
      autoLogin: true,
      // 表单验证对象
      rules: {
        // 设置手机号与验证码的合格条件
        account: [
          {
            required: true,
            message: '请输入员工账号',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入员工密码',
            trigger: 'blur',
          },
          { validator: hasPhone, trigger: 'blur' },
        ],
      },
      loading: false,
      // 需要手机验证码登录
      needCode: false,
      // 手机号
      phone: '',
      // 六位验证码
      loginCode: '',
      // 临时token
      tmpToken: '',
      // 验证码的时间限制
      timeLimit: 0,
      // 验证码计时器
      timer: null,
    };
  },
  computed: {
    loginValid() {
      return this.formData.account && this.formData.password;
    },
    codeValid() {
      return this.loginCode.length === 6;
    },
  },
  methods: {
    login() {
      if (this.loading) return;
      this.loading = true;
      const url = this.$api.login;
      const type = 'post';

      const data = {
        account: this.formData.account,
        password: this.formData.password,
        login_type: 'admin',
      };
      const cb = (data) => {
        if (data.next_step) {
          this.loading = false;
          this.loginStep(data);
        } else {
          this.loginSuccess(data);
        }
      };
      const fault = () => {
        this.loading = false;
      };
      this.$request({ url, cb, type, data, fault, config: this.apiConfig });
    },
    loginWithCode() {
      this.$request({
        url: this.$api.loginWithCode,
        type: 'post',
        data: {
          sms_code: this.loginCode,
          login_type: 'admin',
        },
        tmpToken: this.tmpToken,
        cb: (data) => {
          this.loginSuccess(data);
        },
        config: this.apiConfig,
      });
    },
    async loginSuccess(data) {
      console.log('------loginSuccess------', data);
      console.log('------storage------', this.storage);
      this.$message({
        message: '登录成功',
        type: 'success',
      });
      this.$cookies.set('uin', data.uin);
      this.$cookies.set('saas_token', data.token);
      if (this.storage) {
        this.$cookies.set('uin', data.uin);
        this.$cookies.set('saas_token', data.token);
        setTimeout(() => {
          if (this.redirectUrl) {
            window.location.href = `${this.redirectUrl}?token=${encodeURIComponent(data.token)}`;
          } else {
            gotoHome();
          }
        }, 500);
      } else {
        const userInfo = await this.$request({
          url: this.$api.getUserinfo,
          data: {},
          tmpToken: data.token,
        });
        const tenantInfo = await this.$request({
          url: this.$api.getTenantInfo,
          data: {},
          tmpToken: data.token,
        });
        parent.postMessage(
          {
            saas_token: data.token,
            uin: data.uin,
            user_info: userInfo,
            tenant_info: tenantInfo,
          },
          this.fromUrl,
        );
      }
    },
    loginStep(data) {
      if (data.next_step === LOGIN_STEP.phone) {
        this.tmpToken = data.token;
        this.needCode = true;

        this.$request({
          url: this.$api.loginGetPhone,
          type: 'post',
          data: {},
          tmpToken: this.tmpToken,
          cb: ({ phone }) => {
            if (phone) {
              this.phone = phone;
              this.getCode();
            } else {
              this.$refs.form.validate(() => {
                this.needCode = false;
              });
            }
          },
          config: this.apiConfig,
        });
      }
    },
    getCode() {
      if (this.timer !== null) return;
      this.$request({
        url: this.$api.sendSmsCode,
        type: 'post',
        data: {},
        tmpToken: this.tmpToken,
        config: this.apiConfig,
      });
      this.timeLimit = 30;
      this.timer = setInterval(() => {
        this.timeLimit -= 1;
        if (this.timeLimit === 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    codeChange(code) {
      this.loginCode = code;
    },
  },
};
